// extracted by mini-css-extract-plugin
export var chip = "_46-0";
export var filterDropdown = "_46-5";
export var filterItem = "_46-6";
export var icon = "_46-1";
export var removeButton = "_46-3";
export var removeIcon = "_46-4";
export var separator = "_46-2";